(()=>{
  const readyForms = new WeakSet();
  function connectNewsletter() {
    document.querySelectorAll('form[data-tacit-native-newsletter]').forEach(form => {
      form.removeAttribute('data-tacit-disconnected');
      if (readyForms.has(form) || typeof window.Shopify?.captcha?.protect !== 'function') return;
      readyForms.add(form);
      window.Shopify.captcha.protect(form);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectNewsletter, { once: true });
  else connectNewsletter();
  document.addEventListener('shopify:section:load', connectNewsletter);
})();
